import React, { Component } from "react";
import { connect } from "react-redux";
import { FaPrescription } from "react-icons/fa";

export class CustomerRx extends Component {
  render() {
    return (
      <>
        <button
          className="bbtn"
          onClick={() => this.props.toggleVisible(true, 1)}
          disabled={!this.props.data || this.props.data.length === 0}
        >
          View Customer's <FaPrescription />
        </button>
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerRx);
